import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import MoonboardLanding from "./MoonupdateLanding";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MoonboardLanding />
  </React.StrictMode>
);
